<template lang="pug">
button.controller(:disabled="isDisabled", :class="getClassStatus", @click="clickEvent")
  icon.relative(:name="icon_type[type]")
</template>

<script>
export default {
  name: "Controller",
  props: {
    type: {
      type: String,
      default: "",
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      icon_type: {
        close: "close",
        next: "arrow",
        prev: "arrow",
        plus: "plus",
      },
    };
  },

  computed: {
    getClassStatus() {
      return [
        `controller--${this.type}`,
        {
          "controller--disabled": this.isDisabled,
        },
      ];
    },
  },

  methods: {
    clickEvent(event) {
      if (!this.isDisabled) {
        this.$emit("click", event);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../styles";
</style>
